import React, { FC, KeyboardEvent } from 'react';
import { AddressType, CustomerType } from '../fa-interfaces';
import { TranslationProps } from '../../../contexts/TranslationContext';
import './css/radio-address-type.css';
interface Props {
  addressType: AddressType
  value: CustomerType,
  onChange?: (v: CustomerType) => void;
}

const RadioAddressType: FC<Props & TranslationProps> = ({ textsContent, addressType, value, onChange }): JSX.Element => {
  const items: Record<CustomerType, string> = {
    private: textsContent?.['SHIPPING_FORM_PRIVATE_CUSTOMER'] || 'Particulier',
    pro: textsContent?.['SHIPPING_FORM_COMPANY_CUSTOMER'] || 'Entreprise privée ou publique'
  };

  const handleKeyUp = (event: KeyboardEvent<HTMLLabelElement>): void => {
    const { code, target } = event;
    if (['space', 'enter'].includes(code.toLowerCase()) && target instanceof HTMLLabelElement) {
      target.click();
    }
  };

  return (
    <div className="fa-radio-address-type-group">
      {Object.entries(items).map(([key, label]) => (
        <div key={`fa-radio-${addressType}-${key}`} className="fa-radio-address-type-item">
          <input
            id={`fa-${addressType}-${key}`}
            type="radio"
            name={`fa-${addressType}-address_type`}
            value={key}
            checked={key === value}
            onChange={() => onChange?.(key as CustomerType)}
          />
          <label htmlFor={`fa-${addressType}-${key}`} tabIndex={0} onKeyUp={handleKeyUp}>
            <div className="fa-custom-input-radio"></div>
            <span>{label}</span>
          </label>
        </div>
      ))}
    </div>
  );
};

export default RadioAddressType;
